import { render, staticRenderFns } from "./UserCreationStep1.vue?vue&type=template&id=2c13d37e"
import script from "./UserCreationStep1.vue?vue&type=script&lang=ts"
export * from "./UserCreationStep1.vue?vue&type=script&lang=ts"
import style0 from "./UserCreationStep1.vue?vue&type=style&index=0&id=2c13d37e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports